export enum ShellEventType {
  RefreshClicked = 'refreshClicked',
  TimeRangeChanged = 'timeRangeChanged',
  StateTimeRangeUpdated = 'stateTimeRangeUpdated',
  TriggerThemeSwitch = 'triggerThemeSwitch',
}
